import { IconButton } from '@zillow/constellation-10';
import { IconLightBulbFilled } from '@zillow/constellation-icons';

type RecommendationIconBulbProps = {
  onClick: () => void;
  label: string;
  dataEventid?: string;
};

const RecommendationIconBulb = ({ onClick, label, dataEventid }: RecommendationIconBulbProps) => (
  <IconButton
    emphasis="bare"
    tone="brand"
    size="sm"
    title={`Recommendation for ${label}`}
    data-eventid={dataEventid}
    onClick={onClick}
  >
    <IconLightBulbFilled />
  </IconButton>
);

export default RecommendationIconBulb;
